/**
 *
 * AuthModal
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import Modal from '@material-ui/core/Modal';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _has from 'lodash/has';
import _isEmpty from 'lodash/isEmpty';
import { toast } from 'react-toastify';
import MixPanel from 'utils/mixpanelService';
import {
  makeSelectAuth,
  makeSelectAuthModal,
  makeSelectAuthModalAction,
  makeSelectError,
  makeSelectProcessing,
  makeSelectProfile,
} from 'containers/Auth/selectors';
import {
  signUp,
  setAuthModalState,
  storeItemForSignIn,
} from 'containers/Auth/actions';
import LoadingOverlay from 'components/LoadingOverlay';
import Config from 'utils/getEnvConfig';
import ModalContent from './ModalContent';

class AuthModal extends React.PureComponent {
  componentDidUpdate(prevProps) {
    const {
      action,
      auth,
      error,
      history,
      location,
      modal,
      onClose,
      profile,
    } = this.props;

    if (
      modal.show &&
      prevProps.profile.isEmpty &&
      !profile.isEmpty &&
      _has(auth, 'uid')
    ) {
      let event;
      let shouldIdentify = false;
      if (auth.providerData[0].providerId === 'password') {
        if (action === 'sign-up') {
          event = 'Sign up - Successful';
          MixPanel.alias(auth.uid);
        } else {
          event = 'Login - Successful';
          shouldIdentify = true;
          // MixPanel.identify(auth.uid);
        }
      } else if (Date.now() - auth.createdAt < 5000) {
        event = 'Sign up - Successful';
        MixPanel.alias(auth.uid);
      } else {
        event = 'Login - Successful';
        shouldIdentify = true;
        // MixPanel.identify(auth.uid);
      }

      if (_has(profile, 'email')) {
        MixPanel.track(event, {}, shouldIdentify);

        MixPanel.people.set({
          $name: profile.displayName,
          $email: profile.email,
          $created: profile.createdAt,
          $last_login: profile.lastLoginAt,
          firebaseID: auth.uid,
          gender: profile.gender,
          age: profile.dob,
          socialLogin: auth.providerData[0].providerId,
          sendResourceUpdates: profile.resourcesSubscription || false,
        });

        const emailDomain = profile.email ? profile.email.split('@')[1] : '';
        const shouldEnforceBrand = Object.keys(Config.DOMAINS || {}).filter(
          brand =>
            emailDomain !== '' &&
            Config.DOMAINS[brand].includes(emailDomain.toLowerCase()),
        );
        const enforceBrand =
          shouldEnforceBrand.length > 0 ? shouldEnforceBrand[0] : null;

        if (enforceBrand)
          history.push(`${location.pathname}?brand=${enforceBrand}`);
      } else {
        MixPanel.track(event, {}, shouldIdentify);

        MixPanel.people.set({
          $name: profile.displayName,
          $created: profile.createdAt,
          $last_login: profile.lastLoginAt,
          firebaseID: auth.uid,
          gender: profile.gender,
          age: profile.dob,
          socialLogin: auth.providerData[0].providerId,
        });

        const currentLocation = location.pathname;
        history.push(
          `/signup?completeRegistration=true&redirect=${currentLocation}`,
        );
      }

      onClose();
    }

    if (modal.show && prevProps.error !== error && !_isEmpty(error)) {
      toast(error.message, { type: 'error' });
    }
  }

  handleSignUp = ({ data, provider }) => {
    const { doSignUp } = this.props;
    if (provider === null) {
      this.receiveMarketing = data.marketing;

      doSignUp({
        data,
        provider: null,
      });
    } else {
      doSignUp({
        provider,
      });
    }
  };

  handleCloseModal = () => {
    this.props.storeItemForSignIn({});
    this.props.onClose();
  };

  render() {
    const { action, modal, processing } = this.props;
    return (
      <>
        <Modal open={modal.show}>
          <div>
            <ModalContent
              onClose={this.handleCloseModal}
              onSignUp={this.handleSignUp}
              type={modal.type}
              action={action}
            />
          </div>
        </Modal>
        <LoadingOverlay show={processing} />
      </>
    );
  }
}

AuthModal.propTypes = {
  action: PropTypes.string,
  auth: PropTypes.object,
  doSignUp: PropTypes.func,
  error: PropTypes.object,
  history: PropTypes.object,
  location: PropTypes.object,
  modal: PropTypes.object,
  onClose: PropTypes.func,
  processing: PropTypes.bool,
  profile: PropTypes.object,
  storeItemForSignIn: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
  action: makeSelectAuthModalAction(),
  auth: makeSelectAuth(),
  error: makeSelectError(),
  modal: makeSelectAuthModal(),
  processing: makeSelectProcessing(),
  profile: makeSelectProfile(),
});

function mapDispatchToProps(dispatch) {
  return {
    onClose: () => dispatch(setAuthModalState({ show: false, type: '' })),
    doSignUp: payload => dispatch(signUp(payload)),
    storeItemForSignIn: payload => dispatch(storeItemForSignIn(payload)),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withConnect,
  withRouter,
)(AuthModal);
